import { Component } from "react";
import "../dash.css"
import DashHeader from "../../component/dash_header";
import DashMenu from "../../component/dash_menu";
import { FaFilePdf } from "react-icons/fa";
// import { FaRegEdit} from "react-icons/fa";
import { connect } from "react-redux";
import { FaRegUser } from "react-icons/fa";
import ChatBox from "../../component/chatbox";



class Profile extends Component {
    state = {
        edit: false,
        userInfo: {
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            country: "",
            userPlan: ""
        },
        previews: {
            profile_picture: ""
        },
        loading: false,
        isMenuVisible: false,
        windowWidth: window.innerWidth
    };

    // Toggles the menu visibility
    toggleMenu = () => {
        this.setState((prevState) => ({
            isMenuVisible: !prevState.isMenuVisible
        }));
    };

    // Handle window resize event
    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    // Adjust menu visibility based on window width
    adjustMenuVisibility = () => {
        const { windowWidth, isMenuVisible } = this.state;
        if (windowWidth > 1100 && !isMenuVisible) {
            this.setState({ isMenuVisible: true });
        } else if (windowWidth <= 1100 && isMenuVisible) {
            this.setState({ isMenuVisible: false });
        }
    };

    // Clean up resize event listener when component unmounts
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    // Update menu visibility when window width changes
    componentDidUpdate(prevProps, prevState) {
        if (prevState.windowWidth !== this.state.windowWidth) {
            this.adjustMenuVisibility();
        }
        if (prevProps.user !== this.props.user) {
            this.setState({ userInfo: this.props.user });
        }
    }

    componentDidMount() {
        const { user } = this.props;
        if (user) {
            this.setState({ userInfo: user });
        }
        window.addEventListener("resize", this.handleResize);
        this.adjustMenuVisibility(); // Initial visibility check
    }









    handleProfileInputChange = (event) => {
        const { name, value } = event.target
        this.setState((prevState) => ({
            userInfo: {
                ...prevState.userInfo,
                [name]: value
            }
        }));
    }






    handleFileSelect = (name, event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Save the actual file in userInfo
        this.setState((prevState) => ({
            userInfo: {
                ...prevState.userInfo,
                [name]: file
            }
        }));

        // Save preview or icon
        if (file.type.startsWith("image/")) {
            const previewURL = URL.createObjectURL(file);
            this.setState((prevState) => ({
                previews: {
                    ...prevState.previews,
                    [name]: previewURL
                }
            }));
        } else {
            this.setState((prevState) => ({
                previews: {
                    ...prevState.previews,
                    [name]: "file" // mark as file for icon display
                }
            }));
        }
    };

    triggerFilePicker = (name) => {
        this.activeField = name;
        if (this.fileInputRef.current) {
            this.fileInputRef.current.click();
        }
    };


    render() {
        const { edit, userInfo, previews } = this.state
        const { isMenuVisible } = this.state

        return (
            <div className="dashboard">
                <DashHeader toggleMenu={this.toggleMenu} />
                <div className="dash_body_container">
                    <DashMenu isMenuVisible={isMenuVisible} toggleMenu={this.toggleMenu} />
                    <div className="dash_content_container">
                        <div className="dash_contain">
                            <div className="dash_head">
                                <h3>Profile</h3>
                                <p>Select your preferred payment method</p>
                            </div>

                            <div className="profile_contain">
                                <div className="cover one">
                                    <h3>Personnalized Data</h3>
                                    <div className="pic_container">
                                        <input

                                            type="file"
                                            accept="image/*,application/pdf"
                                            style={{ display: "none" }}
                                            ref={this.fileInputRef}
                                            onChange={(e) => this.handleFileSelect(this.activeField, e)}
                                        />
                                        {/* <button className="edit" onClick={() => this.triggerFilePicker("profile_picture")}><FaRegEdit /></button> */}

                                        {previews.profile_picture ? (
                                            previews.profile_picture === "file" ? (
                                                <FaFilePdf size={40} /> // show icon for pdf/file
                                            ) : (
                                                <img src={previews.profile_picture} alt="Profile" />
                                            )
                                        ) : (
                                            <FaRegUser style={{fontSize: "60px", color : "rgba(0,0,0,0.3)"}} />
                                        )}

                                        <div className="edit">
                                            <div className="contain">
                                                <h4>User</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="input">
                                        <label>First Name</label><br />
                                        <input onChange={this.handleProfileInputChange} type="text" name="firstName" id="firstName" value={userInfo.firstName || ""} placeholder="John" disabled={!edit} />
                                    </div>
                                    <div className="input">
                                        <label>Last Name</label><br />
                                        <input onChange={this.handleProfileInputChange} type="text" name="lastName" id="lastName" value={userInfo.lastName || ""} placeholder="Doe" disabled={!edit} />
                                    </div>

                                </div>
                                <div className="cover two">
                                    <h3>Additional Information</h3>
                                    <div className="input_cover">
                                        <div className="input half">
                                            <label>Email</label>
                                            <input onChange={this.handleProfileInputChange} type="email" name="email" id="email" value={userInfo.email || ""} placeholder="@gmail.com" disabled={!edit} />
                                        </div>
                                        <div className="input half">
                                            <label>Phone Number</label>
                                            <input onChange={this.handleProfileInputChange} type="number" name="phone" id="phone" value={userInfo.phone || 0} placeholder="0900000000" disabled={!edit} />
                                        </div>
                                    </div>
                                    <div className="input_cover">
                                        <div className="input half">
                                            <label>Residential Address</label>
                                            <input onChange={this.handleProfileInputChange} type="text" name="country" id="country" value={userInfo.country || ""} placeholder="10 Lorem street, Lorem estate" disabled={!edit} />
                                        </div>
                                        <div className="input half">
                                            <label>userPlan</label>
                                            <input onChange={this.handleProfileInputChange} type="text" name="userPlan" id="userPlan" value={userInfo.userPlan} placeholder="userPlan" disabled={!edit} />
                                        </div>
                                    </div>


                                    {/* <h3>Link Card </h3>
                                    <div className="input_cover">
                                        <div className="input half">
                                            <label>Email</label>
                                            <input onChange={this.handleProfileInputChange} type="email" name="email" id="email" value={userInfo.email} placeholder="@gmail.com" disabled={!edit} />
                                        </div>
                                        <div className="input half">
                                            <label>Phone Number</label>
                                            <input onChange={this.handleProfileInputChange} type="number" name="phone" id="phone" value={userInfo.phone} placeholder="0900000000" disabled={!edit} />
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ChatBox />
            </div>
        )
    }
}



const mapStateToProps = (state) => ({
    user: state.user,
});




export default connect(mapStateToProps)(Profile) 